export const getHoldingsUnit = (holdingData, symbol) => {
    var _a;
    if (holdingData && (holdingData === null || holdingData === void 0 ? void 0 : holdingData.length) > 0) {
        return (((_a = holdingData.find((holding) => { var _a; return ((_a = holding === null || holding === void 0 ? void 0 : holding.quote) === null || _a === void 0 ? void 0 : _a.symbol) == symbol; })) === null || _a === void 0 ? void 0 : _a.quantity) || 0);
    }
    else {
        return 0;
    }
};
